import { makeStyles } from '@mui/styles';
import styled from 'styled-components';
import EditSvg from 'shared/statics/svg/Edit.svg';
import Close from '@mui/icons-material/Close';
import {
  TableContainer,
  TableRow as TableRowMui,
  Select as SelectMui,
  Button as ButtonMui,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from '@fortawesome/pro-light-svg-icons';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#f9f9f9f9',
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  root: {
    margin: 'auto',
  },
}));

export const TableRoot = styled(TableContainer)`
  table {
    border-spacing: 0px 8px;
    border-collapse: separate;
    padding-left: 24px;
    padding-right: 24px;
  }
  .link.disabled {
    color: #ccc !important;
  }
  .MuiTableHead-root {
    tr {
      height: 16px !important;
      &:hover {
        background-color: transparent;
      }
      th {
        font-weight: 700;
        font-size: 16px;
        color: #48596b;
        border-right: solid 1px #cbd6e2;
        border-bottom: none;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        &:first-of-type {
          color: #0072a2;
        }
        svg {
          transform: translateY(7px);
        }
        &:last-of-type {
          border-right: none;
        }
      }
    }
  }
  .MuiTableBody-root {
    tr {
      background-color: #fff;
      &:hover {
        background-color: #eaf0f6;
        .MuiIconButton-label {
          opacity: 1;
        }
      }
      td {
        font-weight: 400;
        font-size: 16px;
        color: #48596b;
        border-bottom: solid 1px #cbd6e2;
        border-top: solid 1px #cbd6e2;
        padding-bottom: 16px;
        padding-top: 16px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-of-type {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          border-left: solid 1px #cbd6e2;
        }
        &:last-of-type {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border-right: solid 1px #cbd6e2;
        }
        .MuiIconButton-label {
          opacity: 0;
          color: #0072a2;
        }
        .link {
          color: #0091ae;
          padding-left: 5px;
          cursor: pointer;
          &:hover {
            &:after {
              content: '';
              display: inline-block;
              margin-left: 5px;
              width: 17px;
              height: 16px;
              background-size: cover;
              background-image: url(${EditSvg});
            }
          }
        }
      }
    }
  }
`;

export const TableRow = styled(TableRowMui)`
  cursor: pointer;
  &:hover {
    background-color: #0091ae1f;
  }
  .MuiTooltip-popper {
    background-color: #ffffff;
    height: 48px;
  }
`;

export const Heading = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ebf0f6;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  div:first-child {
    position: relative;
  }
  span {
    font-size: 16px;
    font-weight: 700;
    color: #48596b;
  }
  h2 {
    font-size: 32px;
    font-weight: 400;
    color: #48596b;
    margin-top: -8px;
    span {
      color: #0072a2;
      cursor: pointer;
    }
    label {
      font-weight: 700;
      font-size: 24px;
      color: #778ba5;
    }
  }
  .MuiButtonGroup-root {
    width: 100%;
    background-color: white;
    border: solid 1px #cbd6e2;
    padding: 5px;
    max-height: 48px;
    button {
      max-height: 34px;
      justify-content: left;
      span {
        font-size: 16px;
        font-weight: 400;
        color: #535353;
      }
      &:first-of-type {
        width: 100%;
        text-transform: none;
      }
      border: none;
    }
  }
  .options {
    width: 100%;
    transform: translate(0px, 46px);
    z-index: 1;
  }
  .MuiFormControl-root {
    margin-top: -3px !important;
  }
`;

export const RowH = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 17px;
  button {
    text-transform: none;
    height: 48px;
    span {
      color: #ffffff;
      font-size: 16px;
      font-weight: 700;
    }
  }
  .MuiFormControl-root {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 16px;
  }
  input {
    z-index: 1;
    color: #535353;
    font-size: 16px;
    font-weight: 400;
    height: 32px;
  }
  .MuiInputAdornment-root {
    z-index: 1;
  }
  fieldset {
    border: solid 1px #cbcbcb;
    background-color: #ffffff;
  }
  .MuiChip-root {
    background-color: #48596b;
    height: 32px;
    margin-right: 10px;
    max-width: 320px;
    span {
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
    }
    svg {
      color: #ffffff;
    }
  }
`;

export const ToolbarRow = styled(RowH)`
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  .toolbar-field {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    label {
      font-size: 14px;
      font-weight: 700;
      color: #48596b;
      margin-bottom: 6px;
    }
  }
  .toolbar-filter {
    width: 240px;
    .MuiInputBase-root {
      width: 100%;
      max-width: none;
      height: 46px;
    }
  }
  .toolbar-search {
    width: 320px;
    .MuiFormControl-root {
      margin-top: 0px !important;
      margin-right: 0px;
    }
    .MuiInputBase-root {
      height: 46px;
      background-color: #ffffff;
    }
    input {
      height: auto;
    }
  }
  .toolbar-spacer {
    flex: 1 1 auto;
  }
  .toolbar-action button {
    height: 46px;
    white-space: nowrap;
  }
`;

export const ColH = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  &.filters {
    padding-right: 16px;
    max-width: 25%;
    position: relative;
  }
`;

export const LinkClear = styled.span<{ fontSize?: string }>`
  font-size: ${props => props?.fontSize || '16px'} !important;
  font-weight: 400 !important;
  color: #0072a2 !important;
  text-decoration: underline;
  cursor: pointer;
`;

export const Select = styled(SelectMui)`
  height: 53px;
  overflow: hidden;
  .MuiSelect-root {
    z-index: 1;
  }
`;

export const SortDownIcon = styled(FontAwesomeIcon).attrs({
  icon: faArrowDownShortWide,
  className: 'icon',
})`
  display: inline-block;
  transform: translateX(5px) !important;
`;

export const SortUpIcon = styled(FontAwesomeIcon).attrs({
  icon: faArrowUpShortWide,
  className: 'icon',
})`
  display: inline-block;
  transform: translateX(5px) !important;
`;

export const CloseIcon = styled(Close)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const StickyBox = styled.div`
  position: fixed;
  background-color: #ffffff;
  top: 80px;
  right: 10px;
  border-radius: 5px;
  padding: 20px 40px;
  min-width: 400px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;
`;

export const CancelButton = styled(ButtonMui).attrs({
  color: 'primary',
  variant: 'outlined',
  fullwidth: true,
})`
  margin-left: 3px;
  .MuiButton-label {
    color: #0073a3;
  }
`;

export const BoxCenter = styled.div`
  text-align: center;
  padding-top: 60px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
`;
